import { call, put, takeLatest } from 'redux-saga/effects';
import { settingsService } from './service';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';
import { httpRequestsOnLoadActions } from 'store/http_requests_on_load';
import {
  DELETE_ACCOUNT,
  CHANGE_PASSWORD,
  GET_COUNTRIES,
  DELETE_ACCOUNT_SUCCESS,
  GET_COUNTRIES_SUCCESS,
  GET_CITIES,
  GET_CITIES_SUCCESS,
  UPDATE_ACCOUNT,
  UPDATE_USER_AVATAR,
  UPDATE_USER_AVATAR_SUCCESS,
} from './types';

function* updateAccount({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  try {
    yield call(settingsService.updateAccount, payload);
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err.data.reds));
  }
}

function* updateUserAvatar({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  try {
    const response = yield call(settingsService.updateUserAvatar, payload);
    yield put({
      type: UPDATE_USER_AVATAR_SUCCESS,
      payload: response.data,
    });

    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err.data.reds));
  }
}

function* changePassword({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  try {
    yield call(settingsService.changePassword, payload);
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err.data.reds));
  }
}

function* deleteAccount({ payload, type }) {
  try {
    const res = yield call(settingsService.deleteAccount, payload);
    yield put({
      type: DELETE_ACCOUNT_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put(httpRequestsOnErrorsActions.appendError(type, err.data.message));
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

function* getCountries() {
  try {
    const res = yield call(settingsService.getCountries);
    yield put({
      type: GET_COUNTRIES_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    console.log(err);
  }
}

function* getCities({ payload }) {
  try {
    const res = yield call(settingsService.getCities, payload);

    yield put({
      type: GET_CITIES_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    console.log(err);
  }
}

export const watchSettings = function* watchUserSettings() {
  yield takeLatest(UPDATE_ACCOUNT, updateAccount);
  yield takeLatest(CHANGE_PASSWORD, changePassword);
  yield takeLatest(DELETE_ACCOUNT, deleteAccount);
  yield takeLatest(GET_COUNTRIES, getCountries);
  yield takeLatest(GET_CITIES, getCities);
  yield takeLatest(UPDATE_USER_AVATAR, updateUserAvatar);
};
